import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/app/hooks";
import { visibility } from "../../redux/slices/rightSideAd";
import "./AdminNotifications.scss";
import { useLazyQuery } from "@apollo/client";
import { ADMIN_NOTIFICATION } from "./api/AdminNotification";
import {
  NotificationForAdminResponse,
  NotificationForAdminVariables,
} from "./types/AdminNotification";
import Loader from "../../components/Loader/Loader";
import { messages } from "../../utils/constants";
import MobileScreenHeader from "../../components/MobileScreenHeader/MobileScreenHeader";
import { getScreenDimensions } from "../../utils/helper";

const AdminNotification = () => {
  const dispatch = useAppDispatch();
  dispatch(visibility({ isVisible: true }));
  const [notificationData, setNotificationData] =
    useState<NotificationForAdminResponse | null>(null);
  const isNotificationEnable = useAppSelector(
    (state) => state.auth.isNotificationEnabled
  );
  const role = useAppSelector((state) => state.auth.role);
  const profile = useAppSelector((state) => state.auth.adminProfile);
  const profileImage = useAppSelector((state) => state?.auth?.adminProfileImage);
  const StudentName = profile?.getCurrentUser?.nodes?.[0]?.uFullName;

  const [adminNotification, { loading }] = useLazyQuery<
    NotificationForAdminResponse,
    NotificationForAdminVariables
  >(ADMIN_NOTIFICATION, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      setNotificationData(data);
    },
  });

  useEffect(() => {
    if (isNotificationEnable) {
      adminNotification();
    }
  }, [adminNotification, isNotificationEnable]);

  const [isEmpty, setIsEmpty] = useState(false);

  useEffect(() => {
    if (
      !notificationData ||
      ((notificationData?.notificationforAdmin?.allMeetings?.totalCount ?? 0) <=
        0 &&
        (notificationData?.notificationforAdmin?.allCalenders?.totalCount ??
          0) <= 0 &&
        (notificationData?.notificationforAdmin?.allWorkshops?.totalCount ??
          0) <= 0)
    ) {
      setIsEmpty(true);
    } else {
      setIsEmpty(false);
    }
  }, [notificationData]);

  return (
    // <div className="mainContainer-notification">
    <div
      className="AdminNotificationContainer"
      style={{ alignSelf: ((loading || isEmpty) && !getScreenDimensions()?.isMobileScreen ) ? "center" : "flex-start", height: (isEmpty && getScreenDimensions()?.isMobileScreen) ? "80%" : "" }}
    >
      { getScreenDimensions()?.isMobileScreen && 
      <MobileScreenHeader 
       profileImage={profileImage}
       role={role}
       studentName={StudentName}
       profile={profile}
       /> }
      <div className="notificationMobileHeaderContainer">
          <div className="mobileNotificationTitleTextStyle">Notification</div>
      </div>
      {loading ? (
        <div className="noData">
        <Loader /> 
        </div>
      ) : isEmpty && !isNotificationEnable ? (
        <div className="noData">
          <span className="noDataFoundStyle">
            {" "}
            {messages.notificationdisable}{" "}
          </span>
        </div>
      ) : isEmpty ? (
        <div className="noData">
          <span className="noDataFoundStyle"> No data found </span>
        </div>
      ) : (
        <div className="NotificationContainer">
          {/* Calendars */}
          {notificationData &&
            notificationData?.notificationforAdmin.allCalenders.totalCount >
              0 && (
              <div className="EventInnerContainer">
                <div className="Events">
                  <div className="EventDateContainer">
                    <div className="date">Calendars</div>
                    {/* <div className={`${true ? "ActiveDivider" : "divider"}`} /> */}
                  </div>
                  {notificationData.notificationforAdmin.allCalenders.nodes.map(
                    (calendar) => (
                      <div
                        key={calendar.eId}
                        className="EventCard"
                        style={{
                          marginBottom:
                            notificationData?.notificationforAdmin.allCalenders
                              .totalCount > 1
                              ? "10px"
                              : undefined,
                          
                        }}
                      >
                        <div className="EventCardTitle">{calendar.eOriginalTitle}</div>
                        <div className="calender-description">
                          {calendar.eDescription}
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
            )}

          {/* Workshops */}
          {notificationData &&
            notificationData?.notificationforAdmin.allWorkshops.totalCount >
              0 && (
              <div className="EventInnerContainer">
                <div className="Events">
                  <div className="EventDateContainer">
                    <div className="date">Workshops</div>
                    {/* <div className={`${true ? "ActiveDivider" : "divider"}`} /> */}
                  </div>
                  {notificationData.notificationforAdmin.allWorkshops.nodes.map(
                    (workshop) => (
                      <div
                        key={workshop.wsId}
                        className="EventCard"
                        style={{
                          marginBottom:
                            notificationData?.notificationforAdmin.allWorkshops
                              .totalCount > 1
                              ? "10px"
                              : undefined,
                          backgroundColor: "rgba(233, 227, 241, 1)",
                          borderLeft: "10px solid rgba(184, 138, 225, 1)",
                        }}
                      >
                        <div className="EventCardTitle">{workshop.wsTopic}</div>

                        <div className="workshop-innerdiv">
                          <div className="WorkshopStartTime">
                          <span className="type-title">Start Time:{" "}</span>
                          <span className="type-content"> {new Date(workshop.wsStartTime).toLocaleTimeString(
                              [],
                              {
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                              }
                            )}</span>
                          </div>
                          <div className="TeacherStudentEventCartDescription">
                            {workshop.wsDescription}
                          </div>
                        </div>
                      </div>

                    )
                  )}
                </div>
              </div>
            )}

          {/* PTA Meetings */}
          {notificationData &&
            notificationData?.notificationforAdmin.allMeetings.totalCount >
              0 && (
              <div className="EventInnerContainer">
                <div className="Events">
                  <div className="EventDateContainer">
                    <div className="date">PTA Meetings</div>
                    {/* <div className={`${true ? "ActiveDivider" : "divider"}`} /> */}
                  </div>
                  {notificationData.notificationforAdmin.allMeetings.nodes.map(
                    (meeting) => (
                      <div
                        key={meeting.mId}
                        className="EventCard"
                        style={{
                          marginBottom: notificationData?.notificationforAdmin
                            .allMeetings.totalCount
                            ? "10px"
                            : undefined,
                            backgroundColor: "rgba(252, 227, 233, 1)",
                          borderLeft: "10px solid rgba(249, 141, 164, 1)",
                        }}
                      >
                        <div className="pta-Tittle">{meeting.mTopic}</div>

                        <div className="pta-innerdiv">
                          <div className="pta-type">
                            <span className="type-title">Type: </span>
                            <span className="type-content">
                              {meeting.meetingCategoryByMcId.mcOriginalType}
                            </span>
                          </div>
                          <div className="pta-starttime">
                            <span className="type-title">Start Time: </span>
                            <span className="type-content">
                              {" "}
                              {new Date(meeting.mStartTime).toLocaleTimeString(
                                [],
                                {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: true,
                                }
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
            )}
        </div>
        // <></>
      )}
    </div>
    // </div>
  );
};

export default AdminNotification;
